<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="btn-type1">
        <el-button size="mini" type="primary" icon="el-icon-search" @click="goOpen">
          {{ this.$i18n.messages[this.$store.state.locale].search }}
        </el-button>
        <el-button size="mini" type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
      </div>
<!--      <div class="pop-content-search">-->
<!--        <el-form size="mini" label-width="65px">-->
<!--          <el-row :gutter="20">-->
<!--            <el-col :span="12">-->
<!--              <el-form-item label="제조사">-->
<!--                <el-select v-model="maker">-->
<!--                  <el-option-->
<!--                      v-for="item in makerList"-->
<!--                      :key="item.value"-->
<!--                      :label="item.value"-->
<!--                      :value="item.key">-->
<!--                  </el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-form>-->
<!--      </div>-->

      <div class="table-area">
        <div class="table-b">
          <ag-grid-vue
              style="width: 100%; height: 320px;"
              class="ag-theme-alpine"
              row-selection="single"
              ref="grid"
              :frameworkComponents="frameworkComponents"
              :column-defs="columnDefs"
              :grid-options="gridOptions"
              :row-data="rowData"
              :default-col-def="defaultColDef"
              @rowDoubleClicked="rowDoubleClick"
              @grid-ready="onGridReady"
              />
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
  props: {
    tabData: {
      Type: Array
      , required: false
    },
    custNo: {
      Type: String
      , required: false
    }
  },
  components: {Layout, AgGridVue},
  data() {
    return {
      title: '모델선택',

      // AG-GRID OPTION [START]
      rowData:[],
      gridOptions: {},

      maker: '', /** 제조사 */
      makerList: [], /** 제조사 리스트*/
      modelGroup: '', /** 제품군 */
      modelGroupList: [], /** 제품군 리스트*/
      modelGroupNmList: [], /** 제품군 명칭 리스트*/
      subModelGroup: '', /** 제품군 */
      subModelGroupList: [], /** 제품군 리스트*/
      subModelGroupShow: false,
      standardModelNm: '', /** 대표모델 */
      modelNm: '', /** 모델 */
      frameworkComponents: null,
      columnDefs:[
        {
          headerName: '선택'
          , field:'regYn'
          , width : 100
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "1"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "0"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName: '제조사',
          width:400,
          field:'makerNm',
          cellStyle:{textAlign:'center'}
        },
        {headerName:'', field:'makerId', hide : true}
      ],
      defaultColDef: {
        resizable: true,
        filter:true,
        sortable: true
      },
      form: {
        custId: '0',
        siteId: '0'
      }
    }
  },
  mounted() {
    // this.form = this.tabData[0] ? this.tabData[0].param : {}
    this.goOpen();
  },
  beforeMount() {
    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };
  },
  methods: {
    closeModal() {
      this.$parent.close();
    },
    onGridReady(){
      this.getCombo({flag: 'INIT'})
    },
    rowDoubleClick(params){
      this.$emit('close', params.data);
    },
    save() {

      const grid = this.$refs.grid
      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "1"
      })

      this.$emit('close', chkDatas);
      this.closeModal();
    },
    getCombo(param) {
      if(param.flag === 'INIT'){
        // 제조사
        this.$http.get(`/api/codeMng/combo`, {params: {parentId: 196}})
            .then(response => {
              this.makerList = response.data || []
              this.makerList.unshift({key:'', value:'전체'})
            });

      }
    },
    onModelGroupChange(e){
      // 모델이 변경시 하위 제품군 조회
      this.getCombo({flag: '', parentId: e})
    },
    goOpen(){
      this.$store.commit('loading')
      const vModelIdx = this.modelGroupList.findIndex(x=>x.key === this.modelGroup)

      const vform = {
        companyId: this.$store.state.loginInfo.compCd || '',
        catNm : '',
        processTime: ''
      }
      this.$http.post(("/api/obstacleTreatMng/popup/maker"), vform
      ).then(response => {
        if(response.data){
          this.rowData = response.data || []
          this.rowData.unshift({
            makerId:9999,
            makerNm:"공통"
          });
        }
      }).finally(() => {
        this.$store.commit('finish')

      });
    }
  }
}
</script>

<style lang="scss" scoped>
// .modal-card {
//   width: 970px;
// }

// .display-area {
//   :global(img) {
//     width: 100%;
//   }
// }
</style>